import React, { useState } from "react";
import styled from "styled-components";
import { BackButton } from "./BaseTestStyles";

const Container = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #3498db, #2980b9);
  padding: 2rem;
`;

const Content = styled.div`
  max-width: 900px;
  margin: 0 auto;
  background: white;
  border-radius: 20px;
  padding: 2rem;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
`;

const AudioPlayer = styled.div`
  background: #f8f9fa;
  border-radius: 12px;
  padding: 1.5rem;
  margin: 2rem 0;
  text-align: center;
`;

const ProgressBar = styled.div`
  width: 100%;
  height: 8px;
  background: #e9ecef;
  border-radius: 4px;
  margin: 1rem 0;
  position: relative;
  overflow: hidden;

  &::after {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: ${(props) => props.progress}%;
    background: #3498db;
    transition: width 0.3s ease;
  }
`;

const Controls = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin: 1rem 0;
`;

const Button = styled.button`
  background: #3498db;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.3s ease;

  &:hover {
    background: #2980b9;
  }

  &:disabled {
    background: #bdc3c7;
    cursor: not-allowed;
  }
`;

const QuestionSection = styled.div`
  margin: 2rem 0;
`;

const Question = styled.div`
  margin-bottom: 2rem;
`;

const Options = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const Option = styled.label`
  display: block;
  padding: 1rem;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: #f8f9fa;
  }

  input {
    margin-right: 1rem;
  }
`;

const ListeningTest = ({ onBack }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [progress, setProgress] = useState(0);

  // Simulate audio progress
  React.useEffect(() => {
    let interval;
    if (isPlaying && progress < 100) {
      interval = setInterval(() => {
        setProgress((prev) => Math.min(prev + 1, 100));
      }, 100);
    }
    return () => clearInterval(interval);
  }, [isPlaying, progress]);

  const questions = [
    {
      id: 1,
      text: "What is the main topic of the lecture?",
      options: [
        "Climate change effects",
        "Marine biology",
        "Ocean currents",
        "Weather patterns",
      ],
    },
    // Add more questions as needed
  ];

  return (
    <Container>
      <BackButton onClick={onBack}>← Back to Instructions</BackButton>
      <Content>
        <h1>Listening Test - Lecture 1</h1>

        <AudioPlayer>
          <h3>Audio Player</h3>
          <ProgressBar progress={progress} />
          <div>Time: {Math.floor(progress * 0.3)}:00 / 3:00</div>
          <Controls>
            <Button
              onClick={() => setIsPlaying(!isPlaying)}
              disabled={progress === 100}
            >
              {isPlaying ? "Pause" : "Play"}
            </Button>
            <Button onClick={() => setProgress(0)}>Restart</Button>
          </Controls>
        </AudioPlayer>

        <QuestionSection>
          <h2>Questions</h2>
          {questions.map((question, index) => (
            <Question key={question.id}>
              <h3>{`${index + 1}. ${question.text}`}</h3>
              <Options>
                {question.options.map((option, optIndex) => (
                  <Option key={optIndex}>
                    <input
                      type="radio"
                      name={`question-${question.id}`}
                      value={option}
                    />
                    {option}
                  </Option>
                ))}
              </Options>
            </Question>
          ))}
        </QuestionSection>

        <Button
          style={{ float: "right", marginTop: "2rem" }}
          onClick={() => console.log("Next question")}
        >
          Next Question
        </Button>
      </Content>
    </Container>
  );
};

export default ListeningTest;
